import MyDropzone from './MyDropzone';
import React, { useState, useEffect } from 'react';
import filesubnmitted from "./folder-access.ico";
import Icon from '../icons';
import { useUserInfo } from '../../context/user';
import "./style.css";
import SvgIcon from '../icons';

function Index({ classname, refreshchat, updateMemory, gettingmemory, refreshmemory, deleteMemory }) {
  const [alertModel, setAlertModel] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [modelContent, setModelContent] = useState('');
  const [alertcontent, setalertcontent] = useState('');
  const [loader, setloader] = useState(false);
  const [textareaValue, setTextareaValue] = useState(gettingmemory);

  const userActiveLocation = useUserInfo()[4];
  const user = useUserInfo()[0];
  const contextuploadFilefrominput = useUserInfo()[16];

  const gettingfilefromdropzone = async (files) => {
    var response = await contextuploadFilefrominput(files, userActiveLocation?.id, user?.userName);
    if (response === "uploaded") {
      setModelContent("file Submitted ..!");
      setAlertModel(false);
      setSuccessModel(true);
      refreshchat();
    }
  };

  const handleTextareaChange = (e) => {
    setTextareaValue(e.target.value);
  };

  const updatebtn = async () => {
    setloader(true);
    await deleteMemory();
    const result = await updateMemory(textareaValue);
    if (result) {
      setloader(false);
      setalertcontent("Memory updated");
      setAlertModel(false);
      refreshmemory();
    }
  };

  useEffect(() => {
    setTextareaValue(gettingmemory);
    setalertcontent('');
  }, [gettingmemory]);

  return (
    <>
      {alertModel && (
        <div className="modal-zz" onClick={() => setAlertModel(false)}>
          <div className="modal-content-zz position-relative" onClick={(e) => e.stopPropagation()}>
            <p
              style={{
                position: "absolute",
                right: 5,
                width: "12px",
                top: "10px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={() => setAlertModel(false)}
            >
              <SvgIcon id={'close'} />
            </p>
            <h1 style={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "10px" }}>Update Memory</h1>
            <textarea
              name="content"
              rows={6}
              style={{ width: "100%", border: "1px solid black", padding: "10px", borderRadius: "5px", resize: 'none' }}
              value={textareaValue}
              onChange={handleTextareaChange}
            />
            <div className='text-end'>
              <button className='uploadbutton w-100' onClick={updatebtn} disabled={loader}>
                {loader && <SvgIcon id={'spinner'} color="#fff" />} Update
              </button>
            </div>
          </div>
        </div>
      )}
      <button onClick={() => setAlertModel(true)} aria-label="Send message" className={classname} style={{
        backgroundColor: "#4D4D4D", color: "#fff",
        padding: "5px 20px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        marginRight: '20px'
      }}>
        Edit Your AI Assistant Memory
      </button>
    </>
  );
}

export default Index;
